export const themes = {
  default: ({ isScrollable }) => ({
    thHeader: '',
    thList: 'pb-2',
    thListItem: isScrollable ? '' : 'flex-grow',
    thSlot: 'pb-2',
    thBody: '-mt-2',
  }),
  clean: () => ({
    thHeader: 'border-b-1 items-stretch',
    thList: 'whitespace-no-wrap',
    thListItem: 'decorator-separator-left',
    thSlot: 'flex items-center rtl:border-r-1',
    thBody: '-m-px',
  }),
  rounded: ({ isScrollable }) => ({
    thHeader: '-mb-2',
    thList: '',
    thListItem: isScrollable ? '' : 'flex-grow max-w-1/2',
    thSlot: '',
    thBody: 'bg-white rounded-t relative shadow',
  }),
  simple: ({ isScrollable }) => ({
    thHeader: '',
    thList: 'pb-3',
    thListItem: `${isScrollable ? '' : 'flex-grow '}mx-1`,
    thSlot: 'pb-3',
    thBody: '',
  }),
  lite: ({ isScrollable }) => ({
    thHeader: 'mb-3',
    thList: '-mx-1 flex-grow',
    thListItem: `${isScrollable ? 'flex-none ' : ''}mx-1`,
    thSlot: '',
  }),
};
